import { createTheme } from '@material-ui/core/styles';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';

/**
 * 修正非推奨
 * ・修正する場合は、「影響する要素を検索で洗い出し、それをブラウザで目視確認」または、それに相当する確認を行うこと。
 */
const theme = createTheme({
  breakpoints: createBreakpoints({
    values: {
      xs: 0,
      sm: 375,
      md: 560,
      lg: 1024,
      xl: 1920,
    },
  }),
  palette: {
    primary: {
      main: '#00a46e',
    },
    secondary: {
      main: '#F4B43E',
    },
    error: {
      main: '#fe7877',
    },
    action: {
      selected: '#E8F1EC',
    },
    grey: {
      100: '#F7FAFC',
      200: '#EDF2F7',
      300: '#E2E8F0',
      400: '#CBD5E0',
      500: '#A0AEC0',
      600: '#718096',
      700: '#4A5568',
      800: '#2D3748',
      900: '#1A202C',
    },
  },
  typography: {
    fontFamily: ['Hiragino Sans', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    allVariants: {
      color: 'rgba(0, 0, 0, 0.87)',
    },
    h5: {
      fontWeight: 600,
    },
  },
  overrides: {
    MuiButton: {
      contained: {
        boxShadow: 'none',
        padding: '8px 20px',
      },
      sizeSmall: {
        padding: '4px 16px',
      },
    },
    MuiStepIcon: {
      root: {
        '&$completed': {
          color: '#F4B43E',
        },
      },
    },
    MuiPaper: {
      elevation1: {
        boxShadow: 'none',
        border: `1px solid #CBD5E0`,
      },
      elevation2: {
        boxShadow: 'none',
        border: `1px solid #CBD5E0`,
      },
    },
  },
  props: {
    MuiTypography: {
      variant: 'body2',
    },
    MuiButton: {
      variant: 'contained',
      color: 'primary',
    },
    MuiRadio: {
      color: 'primary',
    },
    MuiUseMediaQuery: {
      noSsr: true,
    },
  },
});

export default theme;
